/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Not_Ready_For_ReleaseInputs */

const en_error_inbound_not_ready_for_release = /** @type {(inputs: Error_Inbound_Not_Ready_For_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The units cannot be released yet: Business Central lacks something it needs to record the receipt.`)
};

/**
* | output |
* | --- |
* | "The units cannot be released yet: Business Central lacks something it needs to record the receipt." |
*
* @param {Error_Inbound_Not_Ready_For_ReleaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_not_ready_for_release = /** @type {((inputs?: Error_Inbound_Not_Ready_For_ReleaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Not_Ready_For_ReleaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_not_ready_for_release(inputs)
});